  import Vue from 'vue'
  import App from '@/pad-control/index.vue'
  Vue.config.productionTip = false
  let newVueMore={}
  const I18n = require('@/base/i18n')
  const Messages = require('@/pad-control/i18n/message').default
  I18n.create(Vue, Messages)
  
  const Init =require('@/base/init');
  Init.init(Vue);
    new Vue(Vue.util.extend({
    el: '#app',
    components: { App },
    template: '<App/>',
  }, newVueMore))


//////////////////
// WEBPACK FOOTER
// ./.temp/pad-control/index.js.web.js
// module id = pJdE
// module chunks = 82